// src/components/AnnouncementBanner.jsx
// Pillar B3 — System Settings & Feature Flags
// Shows a global announcement banner when one is set in Admin Board → System.
import { useState, useEffect } from 'react'
import { getAnnouncement } from '../api/kailux'

import Icon from './Icon'
let _bannerCache = null

export function AnnouncementBanner() {
  const [banner, setBanner] = useState(_bannerCache || '')
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    if (_bannerCache !== null) {
      setBanner(_bannerCache)
      return
    }
    getAnnouncement()
      .then(d => {
        _bannerCache = d.announcement || ''
        setBanner(_bannerCache)
      })
      .catch(() => { _bannerCache = '' })
  }, [])

  if (!banner || dismissed) return null

  return (
    <div className="bg-blue-600 text-white text-sm px-4 py-2.5 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <span><Icon name="megaphone" /></span>
        <span>{banner}</span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="text-blue-200 hover:text-white ml-4 text-lg leading-none"
      >×</button>
    </div>
  )
}
